import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextInput from '../atoms/textinput.jsx';
import { Label } from '../atoms/label.jsx';
import { COLOR, SIZE, FONT_FAMILY } from '../../utils/constants.js';
import { PHONE_COUNTRY_CODE } from '../../utils/managereventbooking.js';

// Fixed country code shown beside the input: users only type the number.
const PhoneRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin: ${props => props.margin ? props.margin : '0 0'};
    > div:last-child {
        flex: 1;
    }
    .input-field {
        width: 100%;
        margin: 0;
        padding: 0;
    }
`;

const PhoneInput = (props) => (
    <PhoneRow margin={props.margin}>
        <Label
            margin='0'
            text_size={SIZE.body}
            text_color={COLOR.black}
            font_family={FONT_FAMILY.avenirBlack}>
            { PHONE_COUNTRY_CODE }
        </Label>
        <TextInput
            id={props.id}
            name={props.name}
            type='tel'
            label={props.label}
            placeholder='944555666'
            value={props.value}
            onChange={props.onChange}/>
    </PhoneRow>
);

PhoneInput.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    margin: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func
}

export default PhoneInput;
